import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mrbots.png",
      alt: "Estratégias MR Bots",
    },
    title: "Opere com a M.R Bots",

    // String ou array de strings
    text: [
      "Com mais de 5 anos de Experiência com Investimentos Automatizados, Focamos em trabalhar com Portfólios de Estratégias, Buscando assim Equilíbrio e  Rentabilidade ao longo do tempo. O simples Funciona !!!",
    ],
    testimonial: {
      text: "Equilíbrio, Tempo e Rentabilidade",
      author: {
        name: "Marcelo Jr Ceo M.R Bots",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias M.R Bots",
    heading: "Robôs Craus",
    subtitle: "Estratégias Prontas com Foco No Portfólio",
  },

  cta: {
    title: "Vamos Juntos?",
    subtitle: "Ative agora mesmo a Extensão M.R Bots",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A M.R Bots",
    col1: [
      "A M.R bots nasceu com a finalidade de Ajudar o Investidor No mercado Financeiro . Desenvolvendo Algoritmos com Estratégias Pré Estabelecidas com Foco em Portfólios,Conjunto de Estratégias Trabalhando Juntas, com Correlação negativa e para Absorver Ciclos de Mercado Distinto. Afinal não existe setup Praia. Tire o Emocional de Suas Operações. Vem com a M.R bots",
    ],
    col2: [""],
  },

  stats: {
    title: "Nossos Números",
    subtitle: "Mais de 5 anos de Experiência trabalhando com Robôs",
    data: [
      {
        value: "5",
        description: "Anos de experiência",
      },
      {
        value: "500",
        description: "Clientes",
      },
      {
        value: "1mi",
        description: "Ordens executadas por ano",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da M.R Bots?",
    subtitle: "Veja quais as principais vantagens dos robôs da M.R Bots.",
    data: [
      // {
      //   icon: iconsSet.calendar,
      //   title: "30 dias grátis (clientes BRA - BS)",
      //   description:
      //     "Teste nossas estratégias e confira a performance em sua conta.",
      // },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.lightning,
        title: "Praticidade e tempo",
        description:
          "Os nossos algoritmos conseguem realizar milhares de cáculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        icon: iconsSet.favorite,
        title: "Tire o emocional das suas operações ",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá esse problema!",
      },
      {
        icon: iconsSet.chat,
        title: "Atendimento individual por WhatsApp",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão M.R Bots",
  },

  testimonials: [
    {
      text: "Utilizo os robôs da mr bots a 2 anos, a transparência e resultados tem que ser destacada.",
      author: "Nadia Tita",
      job: "Representante comercial",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "M.R bots Vocês podem Confiar, Atendimento Personalizado, tem como Ceo o Sr Marcelo pessoa de caráter e extrema competência. Sem falsas Promessas e entregando resultados ",
      author: "Caio Rodrigues",
      job: "Vendedor",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};
